import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom'
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../user1000Aside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UI from "components/UI";
import CommonUtil from 'utils/CommonUtil';
import StringUtil from 'utils/StringUtil';
import UIUtils from "utils/UIUtils";
import userStore from "common/user/store/UserStore";
import ModalPopup from "components/modal";

function ContentsContainer() {
    const location = useLocation();
    const [memberInfo, setMemberInfo] = useState({});
    const receivedData = (location.state as any)?.data;
    const history = useHistory();
    const [personId, setPersonId] = useState('');
    const [loginNm,setLoginNm] = useState('');
    const [personNm,setPersonNm] = useState('');
    const [bizNo ,setBizNo] = useState('');
    const [corpNm ,setCorpNm] = useState('');
    const [deptNm ,setDeptNm] = useState('');
    const [emailAdres ,setEmailAdres] = useState('');
    const [hpNo ,setHpNo] = useState('');
    const [ofcTelNo ,setOfcTelNo] = useState('');
    const [posiNm ,setPosiNm] = useState('');
    const [redirectUrl, setRedirectUrl] = React.useState<string>();
    const [modalIsOpen, setmodalIsOpen] = useState(false);

    // 상세 데이터 가져오기
    async function initCall(){

        const response:any = await CommonUtil.execute({
            url: 'usr_1500_r001.jct',
//             data: param,
            progressBar:true
        })

        const result = response;

        //데이터 바인딩
        setMemberInfo(result);

        setLoginNm(result.LOGIN_NM)
        setPersonNm(result.PERSON_NM);
        setDeptNm(result.DEPT_NM);
        setPosiNm(result.POSI_NM);
        setBizNo(result.BIZ_NO);
        setCorpNm(result.CORP_NM);
        setHpNo(result.HP_NO);
        setEmailAdres(result.EMAIL_ADRES);
        setOfcTelNo(result.OFC_TEL_NO);
        setPersonId(result.PERSON_ID);

        // localStorage.setItem("bizNo", result.BIZ_NO);

    };

    //사용자 등록 저장
    async function onClickSave(event) {
        event.preventDefault();

        let param = {
//             PERSON_ID:personId
            LOGIN_NM:loginNm
            ,EMAIL_ADRES:emailAdres
            ,PERSON_NM:personNm
            ,DEPT_NM:deptNm
            ,POSI_NM:posiNm
            ,OFC_TEL_NO:ofcTelNo
            ,HP_NO:hpNo
            ,USE_YN:'1'
            ,USER_LOCALE : "ko_KR"
        }

        if(deptNm == "" || posiNm == "" || ofcTelNo == "") {
            setmodalIsOpen(true);
            return;
        }


        if(await UIUtils.confirm('저장하시겠습니까?')){

            const response:any = await CommonUtil.execute({
                url: "usr_1500.jct",
                data: param
            }).then((response: any) => {
                UIUtils.alert("저장되었습니다.").then(() => {
                    history.push({
                        pathname: '/main',
                    });
                });
            }).catch((error) => {
                CommonUtil.showAxiosError(error);
                return;
            });

        }
    };

    const onClickPage = () => {
        history.push({
            pathname: '/main',
        });
    }

    async function onClose() {
        setmodalIsOpen(false);
    }

    React.useEffect(() => {

        initCall();

    },[])

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="/main/usr_1000/usr_1500">마이페이지</Link></li>
					<li><Link to="#">내정보</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<div className="mypage">
						<h1 className="tx tx-hd2">내정보</h1>
						<div className="top-guide">
							<div className="information">기업담당자가 변경되는 경우 새로 회원가입 바랍니다. 이름, 핸드폰번호, 이메일 주소는 변경불가합니다.</div>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">소속기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={corpNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={personNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">아이디</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={loginNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={deptNm} placeholder={'부서명을 입력해주세요'} valueChanged={(value) => {setDeptNm(value)}}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">직위</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={posiNm} placeholder={'직위를 입력해주세요'} valueChanged={(value) => {setPosiNm(value)}}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">사무실 전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={ofcTelNo} placeholder={'사무실 전화번호를 입력해주세요'} valueChanged={(value) => {setOfcTelNo(value)}}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">휴대폰번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={hpNo} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">이메일주소</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={emailAdres} readOnly={true} />
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-center hz-gap10">
							<Button color='gray-o' size="big" onClick={onClickPage}>취소</Button>
							<Button color='pri' size="big" onClick={onClickSave}>저장</Button>
						</div>
					</div>
				</main>
			</div>
			<ModalPopup
                open={modalIsOpen}
                title={'noTitle'}
                size="alert"
                onClose={() => onClose()}
            >
                <div className="modal-con">
                    <p className="msg">
                        필수 입력이 완료되지 않았습니다.<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;다시 확인해 주세요.
                    </p>
                </div>
                <div className="modal-bottom">
                    <Button color='pri' size="md" onClick={() => setmodalIsOpen(false)}>확인</Button>
                </div>
            </ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;